export default __webpack_public_path__ + "static/media/sponsor.4bb73939.png";